export default __webpack_public_path__ + "static/media/search.3dd43ee6.png";